// extracted by mini-css-extract-plugin
module.exports = {"container":"bPA-TpyvIJEYPgRlo7m0l","divider":"_2VEZYZDjG3yIUSNerVP1HS"};